import component from './landing-header.vue';
import './landing-header.sass';

export default component;
